export default [
    {src_id: '9TrpUIrQw2E', vimeo: "https://vimeo.com/1096563943", ratio: '16:9', title: 'How to connect panels', description: `Hover over a tab and choose the panel you'd like to connect with. Now the connected panel will be updated with new data`},

    {src_id: '0VMM7WZD5to', src_id_dark: 'sEF0maMI53U', ratio: '16:9', title: 'Open a saved session', description: `Hovering over the toolbar and tap the open folder icon  corner of the screen. Now you can open a saved session by clicking on the session name in the list.`},

    {src_id: 'KvWbcoz03WY', src_id_dark: '_EPj0GHZFBM', ratio: '16:9', title: 'Review your schedule', description: `Open the review panel by dragging this handle to the left.`},

    {src_id: 'j5HSdcCpEjg', src_id_dark: 'bP50HfokslE', ratio: '16:9', title: `Got quantities?`, description: `We noticed your diversity score is low - check that quantity values in this column are correct.`},

    

    
]